import { DataTable } from "../DataGrid"
import type { ExportType, Exporter, ExportParams } from "../DataGridContext"
import type { Root } from "react-dom/client"

let rootCreator: undefined | ((el: Element) => Root)

export async function makeExporter<T extends Record<string, unknown>>(
  type: ExportType,
  exportParams: ExportParams
): Promise<Exporter<T>> {
  if (typeof document === "undefined") {
    throw "Client side exporting only"
  }
  const container = document.createElement("div")
  Object.assign(container.style, {
    visibility: "hidden",
    width: 0,
    height: 0,
    overflow: "hidden",
  })
  document.body.appendChild(container)
  if (!rootCreator) {
    const { createRoot } = await import("react-dom/client")
    rootCreator = createRoot
  }

  // NOTE: do NOT destruct render from root https://github.com/facebook/react/issues/26495#issuecomment-1549975519
  const root = rootCreator(container)

  return (props, onDone) => {
    root.render(
      <DataTable
        {...props}
        onFirstDataRendered={(params) => {
          switch (type) {
            case "excel":
              params.api.exportDataAsExcel(exportParams)
              break
            case "csv":
              params.api.exportDataAsCsv(exportParams)
              break
            default:
              throw "Unknown export type"
          }

          document.body.removeChild(container)
          onDone()
        }}
        allowExternalLinks={false}
        enableCharts={false}
        sideBar={false}
        height="0"
      />
    )
  }
}
